import { useFormContext } from "react-hook-form";
import SelectContentLanguage from "../../../Form/SelectContentLanguage";
import { CONTENT_LANGUAGE_PRESET } from "../../../../utils/catalogs/contentLanguage";
import { ADS_CAMPAIGN_LANGUAGE_SELECT_PLACEHOLDER } from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";

const StepLanguage = ({ disabled = false }) => {
  const { t } = useTranslationApp();
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <SelectContentLanguage
      name="language"
      preset={CONTENT_LANGUAGE_PRESET.ALL}
      persistOnChange
      disableClearable={true}
      fullWidth
      variant="filled"
      placeholder={t(ADS_CAMPAIGN_LANGUAGE_SELECT_PLACEHOLDER)}
      control={control}
      errors={errors}
      disabled={disabled}
    />
  );
};

export default StepLanguage;
